<template>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="page-header centrer">
            <div class="row">
              <div class="col-11"/>
              <div class="col-1 text-right no-print">
                <Button label="Imprimer" v-on:click="imprimer"/>
              </div>
            </div>
            <div class="row">
              <div class="col-1"/>
              <div class="col-10">
                <h1>Audits d'accès Dossier</h1>
              </div>
              <div class="col-1 text-right no-print">
                  <Button label="Fermer" v-on:click="fermer"/>
              </div>
            </div>
            <h3 class="confidentiel">Confidentiel</h3>
            <h3 v-if="isDataLoaded">
              Dossier : {{ numeroCardex }} <br />
              Créé par : {{ createur }} <br />
              Le : {{ dateCreation }}
            </h3>
            <div v-else>
              <Skeleton />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <table class="centrer">
            <thead>
              <tr>
                <td>
                  <!--place holder for the fixed-position header-->
                  <div class="page-header-space"></div>
                </td>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>
                  <!--*** CONTENT GOES HERE ***-->
                  <div>
                    <TableAcces
                      @createur="getCreateur"
                      @dateCreation="getDateCreation"
                      @isDataLoaded="getIsDataLoaded"
                    />
                  </div>
                </td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <td>
                  <!--place holder for the fixed-position footer-->
                  <div class="page-footer-space"></div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="page-footer centrer">
            <p>Généré le {{ getCurrentDateTime() }} par {{ currentUser }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableAcces from "../../components/dossier/AuditAcces/TableAcces.vue";
import commun from "../../commun";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "dossierAuditAcces",
  components: {
    TableAcces,
  },
  data() {
    return {
      createur: "",
      dateCreation: "",
      currentUser: "",
      isDataLoaded: false,
    };
  },
  computed: {
    ...mapGetters({
      numeroCardex: "dossier/numeroCardex",
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    assignerInformationUtilisateur(res) {
      this.currentUser = res.data.codeProfilUtilisateur;
    },
    fermer() {
        this.$root.$refs.breadcrumbComp.rediriger();
    }, 
    getCurrentDateTime() {
      return commun.formatDateHeure(new Date());
    },
    getDateCreation(value) {
      this.dateCreation = value;
    },
    getCreateur(value) {
      this.createur = value;
    },
    getIsDataLoaded(value) {
      this.isDataLoaded = value;
    },
    imprimer(){
      window.print();
    }
  },
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Audit des accès Dossier");
    this.$store.dispatch("vehicule/obtenirProfilAction").then((res) => {
      this.assignerInformationUtilisateur(res);
    });
  },
};
</script>